import React from 'react';
import {
  Row, Col, Table, Button,
} from 'react-bootstrap';
import AffiliationTableBody from './AffiliationTableBody';
import AffiliationTableHeader from './AffiliationTableHeader';
import { titles } from './constants';

export default class AffiliationTable extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Table id="affiliation-table" condensed hover responsive>
        <AffiliationTableHeader titles={titles} />
        <AffiliationTableBody />
      </Table>
    );
  }
}
